import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  ActivatedRoute as NgActivatedRoute,
  ParamMap,
  Params,
  Router,
} from '@angular/router';
import { environment } from 'src/environments/environment';
import { IOrganisationEditConfig } from 'src/interfaces/organisation-edit-config';
import { IListingDataSourceConfig } from 'src/app/interfaces/listing-data-source-config';
import { IOrganisation } from 'src/app/interfaces/organisation';
import { CarouselImageDataSource } from 'src/modules/carousel-image/services/carousel-image-data-source';
// import {ListingApiService} from '@module/listing/services/listing-api-service';
import { LocationsList } from 'src/modules/location/components/list/component';
// import {OrganisationDataSource} from '@module/organisation/services/organisation-data-source';
import { ProductInfoApiService } from 'src/modules/product-info/services/product-info-api-service';
// import {EventsList} from '@module/role/organisation-admin/components/event/list/component';
import { Subscription as RxSubscription, switchMap } from 'rxjs';

// import {OrganisationCarouselImageApiService} from '../../../services/carousel-image-api-service';
import { OrganisationAdminApiService } from '../../../services/organisation-admin-api-service';
import { OrganisationDataSource } from 'src/modules/organisation/services/organisation-data-source';
import { OrganisationCarouselImageApiService } from '../../../services/carousel-image-api-service';
// import {ListingsList} from '../../listing/list/component';
import { OrganisationsEdit } from '../edit/component';
import { OrganisationsMemberList } from '../member-list/component';

@Component({
    selector: 'organisation-manage',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class OrganisationsView implements OnInit, OnDestroy {
  public leisureUrl: string = environment.leisureUrl;
  // public imageUrl: string = environment.endpoint.companyImage();

  public loading: boolean;
  public Organisation: IOrganisation;
  public CarouselImageDataSource: CarouselImageDataSource;
  private OrganisationDataSource: OrganisationDataSource;
  private Subscriptions: RxSubscription[] = [];
  private DataSourceConfig: IListingDataSourceConfig;

  private ActiveRouteParams: Params;
  public data;
  constructor(
    private dialog: MatDialog,
    private OrganisationAdminApi: OrganisationAdminApiService,
    // private ListingApi: ListingApiService,
    private ActivatedRoute: NgActivatedRoute,
    private Router: Router,
    private CarouselImageService: OrganisationCarouselImageApiService,
    private ProductApi: ProductInfoApiService
  ) {
    this.data = Router.getCurrentNavigation().extras.state['data'];
  }

  ngOnInit() {
    this.OrganisationDataSource = new OrganisationDataSource(
      'organisation-admin',
      this.OrganisationAdminApi,
      this.data.id
    );
    this.Subscriptions.push(
      this.ActivatedRoute.params.subscribe((params) => {
        this.ActiveRouteParams = params;
        this.init();
      })
    );
  }

  public listMembers() {
    const config = new MatDialogConfig();
    config.data = this.Organisation;
    return this.dialog.open(OrganisationsMemberList, config);
  }

  public listLocations() {
    const config = new MatDialogConfig();
    config.data = this.Organisation;
    return this.dialog.open(LocationsList, config);
  }

  public edit(Organisation: IOrganisation) {
    const config = new MatDialogConfig();
    const data: IOrganisationEditConfig = {
      organisationId: this.ActiveRouteParams['organisationId'],
      Organisation,
      OrganisationDataSource: this.OrganisationDataSource,
      CarouselImageDataSource: this.CarouselImageDataSource,
    };
    config.disableClose = true;
    config.data = data;
    this.Subscriptions.push(
      this.dialog
        .open(OrganisationsEdit, config)
        .afterClosed()
        .subscribe((result) => !!result && this.load())
    );
  }

  public listCarousel() {
    this.CarouselImageDataSource.viewList('organisation-admin');
  }

  public listListings(Organisation: IOrganisation) {
    // const config = new MatDialogConfig();
    // config.data = Organisation;
    // config.disableClose = true;
    // this.dialog.open(ListingsList, config);
  }

  public listEvents(Organisation: IOrganisation) {
    // const config = new MatDialogConfig();
    // config.data = Organisation;
    // config.disableClose = true;
    // this.dialog.open(EventsList, config);
  }

  public listProductInfo() {
    const ProductInfoDataSource = this.ProductApi.getDataSource(
      this.DataSourceConfig
    );
    this.Subscriptions.push(
      ProductInfoDataSource.list()
        .afterClosed()
        .subscribe(() => ProductInfoDataSource.disconnect())
    );
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }

  private init() {
    this.load().then(() => {
      this.DataSourceConfig = {
        role: 'organisation-admin',
        organisationId: this.Organisation.id,
        listingId: this.Organisation.product_id,
      };
      this.CarouselImageDataSource = this.CarouselImageService.getDataSource(
        this.DataSourceConfig
      );
      this.CarouselImageDataSource.load();
    });
  }

  private load() {
    const organisationId = this.ActiveRouteParams['organisationId'];

    this.loading = true;
    this.Organisation = null;
    return this.OrganisationDataSource.getById(organisationId)
      .then((Organisation: IOrganisation) => {
        this.loading = false;

        this.Organisation = Organisation[0];
      })
      .catch(() => (this.loading = false));
  }
}
